import { Tag } from "antd";
import {
  getThreadStatusDisplay,
  isThreadCompleted,
} from "../../helpers/threadStatus";

const ThreadStatusTag = ({ thread }) => {
  const statusDisplay = getThreadStatusDisplay(thread);
  const completed = isThreadCompleted(thread);

  return (
    <Tag
      color={completed ? "success" : statusDisplay.color}
      className={completed ? "thread-status-tag--completed" : undefined}
    >
      {statusDisplay.label}
    </Tag>
  );
};

export default ThreadStatusTag;
